import React, { useEffect, useState } from "react";
import { Avatar, Checkbox, FormControlLabel, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Modal from "../../components/Modal/Modal";
import InputLabel from "../../components/Inputs/InputLabel";
import SnackBar from "../../components/SnackBar/SnackBar";
import SimpleBackdrop from "../../components/Loading/SimpleBackdrop";
import { AlertInfo } from "../../components/Alerts/Alert";
import { api } from "../../services/api";

type ParagrafosProps = {
    openModal: boolean
    setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
}

type ParagrafosPadrao = {
    id_paragrafo_escritorio?: number
    tipo_paragrafo: string
    paragrafo: string
    variavel: string
}

type TextoProps = {
    id_paragrafo: number
    tipo_paragrafo: string
    variavel: string
    paragrafo: string
};


export default function Paragrafos({ openModal, setOpenModal }: ParagrafosProps) {
    const [loading, setLoading] = useState(false);
    const [paragrafosPadrao, setParagrafosPadrao] = useState<ParagrafosPadrao[]>([]);
    const [paragrafosEscritorio, setParagrafosEscritorio] = useState<ParagrafosPadrao[]>([]);
    const [tipo_paragrafo, setTipoParagrafo] = useState("");
    const [variavel, setVariavel] = useState("");
    const [id_paragrafo_escritorio, setIdParagrafoEscritorio] = useState(0);
    const [openModalEdit, setOpenModalEdit] = useState(false);
    const [titleModalEdit, setTitleModalEdit] = useState("");
    const [isEditText, setIsEditText] = useState(false);
    const [text, setText] = useState("");
    const [snackprops, setSnackProps] = useState({ open: false, text: '' });

    const [textos, setTextos] = useState<TextoProps[]>([]);

    function editParagrafo(p: string, t: string) {
        const filE = paragrafosEscritorio.filter(i => i.variavel === p);
        const filP = paragrafosPadrao.filter(i => i.variavel === p);
        if (filE.length === 1) {
            setTitleModalEdit(t);
            setIsEditText(true);
            setText(filE[0].paragrafo);
            setOpenModalEdit(true);
            setTipoParagrafo(p);
            setIdParagrafoEscritorio(filE[0].id_paragrafo_escritorio || 0);
            setVariavel(filE[0].variavel || '');
        } else if (filP.length === 1) {
            setTitleModalEdit(t);
            setText(filP[0].paragrafo);
            setVariavel(filP[0].variavel);
            setOpenModalEdit(true);
            setTipoParagrafo(p);
        } else {
            setSnackProps({ open: true, text: "Paragrafo não encontrado" });
        }
    }

    async function saveParagrafo() {
        setLoading(true);
        try {
            let channel = '/paragrafopadrao';
            if (isEditText) {
                if (id_paragrafo_escritorio) channel = `/updateparagragoescritorio`;
                else channel = '/createparagrafo'
            }
            const data = { paragrafo: text, id_paragrafo_escritorio, tipo_paragrafo, variavel };
            const response = await api.post(channel, data);
            if (response.data.success) {
                AlertInfo({ icon: 'success', title: 'Dados Gravados' });
                loadData();
                setOpenModalEdit(false);
            } else if (response.data.error) {
                AlertInfo({ icon: 'error', title: response.data.msg });
            }
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na conexão' });
        }
        setLoading(false);
    }

    async function loadTexts() {
        try {
            const response = await api.get(`/paragrafospadrao`);
            if (response.data && response.data[0]) setTextos(response.data);
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na conexão' });
        }
    }

    async function loadData() {
        try {
            const response = await api.get(`/paragrafos`);
            if (response.data.success) {
                setParagrafosPadrao(response.data.padrao);
                setParagrafosEscritorio(response.data.escritorio);
            }
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na conexão' });
        }
    }

    useEffect(() => {
        if (!openModalEdit) {
            setTitleModalEdit('');
            setIsEditText(false);
            setText('');
            setTipoParagrafo('');
            setIdParagrafoEscritorio(0);
        }
    }, [openModalEdit]);

    useEffect(() => {
        loadTexts();
        loadData();
    }, []);

    return (
        <Modal
            open={openModal}
            setOpen={setOpenModal}
            title="PARAGRAFOS DOCUMENTOS"
        >
            <Modal
                open={openModalEdit}
                setOpen={setOpenModalEdit}
                title={titleModalEdit}
                maxWidth="md"
                buttonActions={[{ color: 'success', text: 'SALVAR', handle: saveParagrafo }]}
            >
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={isEditText}
                            onChange={() => setIsEditText(!isEditText)}
                        />
                    }
                    label={`PERSONALIZAR ${titleModalEdit}`}
                />
                <InputLabel
                    label="Texto"
                    multiline
                    rows={6}
                    disabled={!isEditText}
                    value={text}
                    setState={setText}
                />
                <SimpleBackdrop open={loading} zIndex={9999} />
            </Modal>


            <List>
                {textos.map((txt, index) => (
                    <ListItem disablePadding key={index} >
                        <ListItemButton onClick={() => editParagrafo(txt.variavel, txt.tipo_paragrafo)}>
                            <ListItemAvatar>
                                <Avatar sx={{ background: '#000' }}>
                                    <ChevronRightIcon sx={{ color: '#fff' }} />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={txt.tipo_paragrafo.toUpperCase()} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>

            <SnackBar value={snackprops} setValue={setSnackProps} />
        </Modal>
    );
}